var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('o-cross-table',{attrs:{"column-headers":_vm.header_data,"column-headers-config":_vm.header_config,"debug":_vm.debug,"row-headers":_vm.row_headers,"row-headers-config":_vm.row_config,"values":_vm.data},scopedSlots:_vm._u([{key:"header-cell",fn:function(ref){
var item = ref.item;
return [_vm._v("\n        "+_vm._s(item.data.name)+"\n    ")]}},{key:"row-header",fn:function(ref){
var item = ref.item;
return [(item && item.data)?_c('span',[_vm._v(_vm._s(item.data.name))]):_vm._e()]}},{key:"value-cell",fn:function(ref){
var items = ref.items;
var colHeader = ref.colHeader;
var rowHeader = ref.rowHeader;
return _vm._l((items),function(item,index){return _c('span',{key:index},[_vm._v("\n            ["+_vm._s(item.label)+"]\n        ")])})}}])})}
var staticRenderFns = []

export { render, staticRenderFns }